import { render, staticRenderFns } from "./ReportLocationTruck.vue?vue&type=template&id=32136ad8&scoped=true"
import script from "./ReportLocationTruck.vue?vue&type=script&lang=ts"
export * from "./ReportLocationTruck.vue?vue&type=script&lang=ts"
import style0 from "./ReportLocationTruck.vue?vue&type=style&index=0&id=32136ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32136ad8",
  null
  
)

export default component.exports